export default __webpack_public_path__ + "static/media/goodMeter.236652d3.svg";